import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { EnvironmentService } from '@patient-ui/shared-ui/utils';

import { LoaderService } from './loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(
    public loaderService: LoaderService,
    private readonly environmentService: EnvironmentService
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Orbi (AI agent) requests must NOT trigger the page-wide loader: the panel
    // has its own in-place loading UI (the "thinking" turn + disabled input), so
    // a global loader would dim/"load" the whole portal behind the panel on
    // every agent call (PCSA-13312). Let those requests through untracked.
    if (this.isOrbiRequest(req)) {
      return next.handle(req);
    }
    this.loaderService.show();
    return next.handle(req).pipe(finalize(() => this.loaderService.hide()));
  }

  private isOrbiRequest(req: HttpRequest<unknown>): boolean {
    const orbiBaseUrl = this.environmentService.orbiApiBaseUrl;
    return !!orbiBaseUrl && req.url.startsWith(orbiBaseUrl);
  }
}
